import { render, staticRenderFns } from "./bookSuggestions.vue?vue&type=template&id=8f5c4746&scoped=true&"
import script from "./bookSuggestions.vue?vue&type=script&lang=js&"
export * from "./bookSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./bookSuggestions.vue?vue&type=style&index=0&id=8f5c4746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5c4746",
  null
  
)

export default component.exports